import { OperatorFunction } from 'rxjs';

export interface DialogIoModel {
    inputs?: {
        [key: string]: any;
    };
    outputs?: {
        [key: string]: Function;
    };
}

/**
 * Caller must specify the keys to be used in the output as a const string array
 * e.g., const keys = ['someKey', 'someOtherKey'] as const;
 */
type OutputModel<T extends readonly string[]> = {
    [K in T[number]]: Function;
};

interface DialogCloseOperator {
    dialogCloseOperator: OperatorFunction<any, any>;
};

type ObservableOutputModel<T extends readonly string[]> = OutputModel<T> | (OutputModel<T> & DialogCloseOperator) | DialogCloseOperator;

/**
 * Used to chain dialog results together asynchronously.
 * Note that dialogCloseOperator is an OperatorFunction, which means it should be assigned a
 * function that accepts an observable and returns an observable
 *
 * E.g.
*   const io: DialogIoModelObservable = {
        outputs: {
            dialogCloseOperator: filter((confirmed: boolean) => !!confirmed)
        },
    };
 */
export interface DialogIoModelObservable extends DialogIoModel {
    dialogCloseOperator?: OperatorFunction<any, any>;
};

export function outputIncludesDialogCloseOperator(ioModel: DialogIoModelObservable): ioModel is DialogCloseOperator {
    return 'dialogCloseOperator' in ioModel;
}
